import { render, staticRenderFns } from "./the-sidebar-header.vue?vue&type=template&id=a60de3fe"
import script from "./the-sidebar-header.vue?vue&type=script&lang=ts"
export * from "./the-sidebar-header.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports